var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHtml(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 110,
    height: 109,
    viewBox: "0 0 110 109",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.97257 98.1039L0 0H109.578L99.5926 98.0883L54.7226 109L9.97257 98.1039Z",
    fill: "#E44F26"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M54.7892 100.661L91.0491 91.8442L99.5793 8.02316H54.7892V100.661Z",
    fill: "#F1662A"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M54.7892 44.4058H36.6371L35.3855 32.0849H54.7892V20.0521H54.7404H20.3934L20.7218 23.2832L24.0904 56.4387H54.7892V44.4058Z",
    fill: "#EBEBEB"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M54.7892 75.6538L54.7271 75.6694L39.4509 72.0529L38.4745 62.457H31.0495H24.7029L26.6246 81.3451L54.7271 88.1888L54.7892 88.1732V75.6538Z",
    fill: "#EBEBEB"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M54.7404 44.4058V56.4386H71.6321L70.0432 72.0451L54.7404 75.6655V88.1849L82.8651 81.3451L83.0693 79.3131L86.2914 47.6369L86.6287 44.4058H82.9317H54.7404Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M54.7404 20.0521V27.5264V32.0577V32.0849H87.8314H87.8758L88.151 29.3833L88.7768 23.2832L89.1052 20.0521H54.7404Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHtml);
export default __webpack_public_path__ + "static/media/html.1e736918b5ae317047d9e6ca5a9327e3.svg";
export { ForwardRef as ReactComponent };